export const FREE_RIDE_CLASS_SESSION_ID = process.env.FREE_RIDE_CLASS_SESSION_ID || '57234af5-0ad1-4deb-b1ca-310831496666';